import React, { useEffect, useState } from "react"; 

const countries = [
  { name: "UK", timeZone: "Europe/London" },
  { name: "Nigeria", timeZone: "Africa/Lagos" },
  { name: "India", timeZone: "Asia/Kolkata" },
  { name: "USA (New York)", timeZone: "America/New_York" },
  { name: "UAE", timeZone: "Asia/Dubai" },
];

const TimeComponent = () => {
  const [selectedCountries, setSelectedCountries] = useState(() => {
    const saved = sessionStorage.getItem("selectedCountries");
    return saved ? JSON.parse(saved) : ["India", "UK"];
  });

  const [timeData, setTimeData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTime = {};
      selectedCountries.forEach((country) => {
        const timeZone = countries.find((c) => c.name === country)?.timeZone;
        if (timeZone) {
          updatedTime[country] = new Date().toLocaleTimeString("en-GB", {
            timeZone,
            hour12: false,
          });
        }
      });
      setTimeData(updatedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [selectedCountries]);

  useEffect(() => {
    sessionStorage.setItem("selectedCountries", JSON.stringify(selectedCountries));
  }, [selectedCountries]);

  const handleAddCountry = (e) => {
    const selected = e.target.value;
    if (!selectedCountries.includes(selected)) {
      setSelectedCountries([...selectedCountries, selected]);
    }
    setModalOpen(false);
  };

  const handleRemoveCountry = (country) => {
    setSelectedCountries((prev) => prev.filter((c) => c !== country));
  };

  return (
    <div className="time-wrapper">
      <div className="time-list">
        {selectedCountries.map((country) => (
          <span key={country} className="time-span">
            <strong>{country}:</strong> {timeData[country] || "--:--:--"}
            <span
              className="remove-btn"
              onClick={() => handleRemoveCountry(country)}
              title="Remove"
            >
              &times;
            </span>
          </span>
        ))}
        <span className="new-project-btn" onClick={() => setModalOpen(true)}>
          +
        </span>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h5>Select a Country</h5>
            <select
              className="form-control mt-2"
              onChange={handleAddCountry}
              defaultValue=""
            >
              <option value="" disabled>
                -- Select Country --
              </option>
              {countries
                .filter((c) => !selectedCountries.includes(c.name))
                .map((country) => (
                  <option key={country.name} value={country.name}>
                    {country.name}
                  </option>
                ))}
            </select>
            <button
              className="btn btn-secondary mt-3"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeComponent;
